import { Dispatch } from "redux"
import { getCustomers } from "../../api/customersApi"
import { CustomersAction, CustomersActionTypes } from "../types/customers"

const fetchCustomers = () => {
  return async (dispatch: Dispatch<CustomersAction>) => {
    try {
      dispatch({
        type: CustomersActionTypes.FETCH_CUSTOMERS_LIST,
      })

      const customers = await getCustomers()
      dispatch({
        type: CustomersActionTypes.FETCH_CUSTOMERS_LIST_SUCCESS,
        payload: customers,
      })
    } catch (e) {
      dispatch({
        type: CustomersActionTypes.FETCH_CUSTOMERS_LIST_ERROR,
        payload: "Customers load error",
      })
    }
  }
}

export default {
  fetchCustomers,
}
